import Afastamento from '../AfastamentoView.vue'

export const afastRoute = [
  {
    path: '/afastamento/',
    name: 'afast',
    component: Afastamento,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'afas_page'
    }
  }
]
